import type { Action } from 'react-sweet-state';

import type { FieldValuesPartial } from '../../../../common/types/form/form-fields/field-values';
import { currentValuesSelector } from '../../selectors/current-values';
import { getAllVisibleFieldIdsSelector } from '../../selectors/get-all-visible-field-ids';
import type { FormRendererState } from '../../types';

/**
 * This action returns only visible values, note a FieldValue can be undefined if empty
 * But we still need to return a value for every visible field
 */
export const getVisibleFieldValues =
	(): Action<FormRendererState, void, FieldValuesPartial> =>
	({ getState }) => {
		const state = getState();
		const currentValues = currentValuesSelector(state);
		const visibleFieldIds = getAllVisibleFieldIdsSelector(state);

		return visibleFieldIds.reduce<FieldValuesPartial>(
			(accum, fieldId) => ({
				...accum,
				[fieldId]: currentValues[fieldId],
			}),
			{},
		);
	};
